import styled from "styled-components";
import { Button as AntButton } from 'antd';

export const RootContainer = styled.div`
padding: 16px;
height: calc(100vh - 102px);
overflow-y: auto;
`;

export const Container = styled.div`
height: calc(100% - 52px);
`;

export const Loader = styled.div`
height: calc(100% - 52px);
display: flex;
align-items: center;
justify-content: center;
`;

export const EmptyBox = styled.div`
		height: calc(100% - 52px);
		width: 100%;
		
    display: flex;
    flex-direction: column;
    gap: 0;
    align-items: center;
    justify-content: center;

    svg {
        font-size: 24px;
        color: #808080;
    }
`;

export const EmptyText = styled.div`
	color: #979797;
	text-align: center;
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 30px; /* 150% */
`;

export const Item = styled.div`
	margin-bottom: 16px;

	display: flex;
	flex-direction: column;
	gap: 8px;

	.ant-space .ant-space-item {
			flex: 1;
	}
`;

export const Divider = styled.div`
width: 100%;
height: 1px;
border-bottom: 1px dashed #999;
`;

export const DateBox = styled.div`
	color: #1C1C1C;
	text-align: left;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5;
`;

export const Text = styled.div`
	overflow: hidden;
	color: #1C1C1C;
	text-overflow: ellipsis;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 26px; /* 162.5% */
`;

export const LightText = styled.p`
	color: #1C1C1C;
	text-align: right;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 26px; /* 162.5% */
`;

export const StatusBox = styled.div`
	padding: 2px 12px;
	height: 24px;
	border-radius: 100px;
	display: inline;
	background: ${props => props.$pending ? "#FF6262" : "#E39401"};
	width: fit-content;

	font-size: 10px;
	font-weight: 400;
	color: ${props => props.$pending ? "#fff" : "#fff"};

	display: flex;
	align-items: center;
	gap: 4px;
`;

export const Button = styled(AntButton)`
	box-sizing: border-box !important ;
	width: 100%;
	height: 52px !important;
`;

export const TopBox = styled.div`
	padding: 16px;
	margin-bottom: 16px;
	background: #E39401;
	border-radius: 8px;

	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;

	color: #FFF;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 26px; /* 162.5% */
`;

export const DataContainer = styled.div`
	border-radius: 8px;
	background: #F7F7F7;
	padding: 16px;

	display: flex;
	flex-direction: column;
	gap: 10px;
`